import { SolutionStep } from '../types';

interface SolutionFlowProps {
  steps: SolutionStep[];
  highlight?: string;
}

export default function SolutionFlow({ steps, highlight }: SolutionFlowProps) {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">我们怎么解决</h3>
          <p className="text-gray-500 text-sm">让风险变得可控、可解释、可追溯</p>
        </div>

        {highlight && (
          <div className="bg-gradient-to-r from-teal-50 to-emerald-50 border border-teal-200 rounded-2xl p-8 mb-12 text-center">
            <h4 className="text-xl font-bold text-gray-900 mb-2">{highlight}</h4>
          </div>
        )}

        <div className="grid md:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <div key={idx} className="relative">
              <div className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-lg transition-all h-full">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-teal-50 text-[#14B8A6] mb-4">
                  <i className={`${step.icon} text-2xl`}></i>
                </div>
                <h4 className="text-base font-bold text-gray-900 mb-2">{step.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-2xl text-gray-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}